export default "__VITE_ASSET__BIiqj2$C__"